import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/gmjt/显微物镜.png';
const _hoisted_1 = {
  class: "gmjt-wrapper"
};
const _hoisted_2 = {
  class: "gmjt-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "right-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "section"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Gmjt',
  setup(__props) {
    // 组件已通过unplugin-vue-components自动注册为全局组件，无需手动导入
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '光学镜头'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SideMenu, {
        activeId: "gmjt"
      }), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "page-title"
      }, "超高通量显微物镜", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "publish-time"
      }, "发布时间：2025年1月1日", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "超高通量显微物镜"
      })], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "产品介绍"
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-content"
      }, [_createElementVNode("p", null, "超高通量干式显微物镜,具有超大视场、超高分辨率的性能优势,产品适用于高通量精密检测高端应用需求,例如生命科学、基因测序、半导体工业检测等领域。")], -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SectionTitle, {
        title: "主要参数"
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "params-content"
      }, [_createElementVNode("div", {
        class: "params-title"
      }, "产品特点"), _createElementVNode("div", {
        class: "params-list"
      }, [_createElementVNode("p", null, "工作谱段:紫外、可见光、近红外"), _createElementVNode("p", null, "视场:>1.0mm"), _createElementVNode("p", null, "数值孔径NA:>0.9"), _createElementVNode("p", null, "畸变:<0.01%")])], -1))])])])]), _createVNode(_component_Footer)]);
    };
  }
});